import React, { useState, useEffect, useRef } from 'react';
import Accordion from '@mui/material/Accordion';
import PropTypes from 'prop-types';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import { FaApplePay } from 'react-icons/fa';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { faPlus, faInr, faMinus } from '@fortawesome/free-solid-svg-icons';
import Skeleton from '@mui/material/Skeleton';
import { Button } from '@mui/material';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import ImageComponents from '../../../Shared/ImageComponents';
import CreditCard from '../../PaymentMode/Components/CreditCard/CreditCard';
import DebitCard from '../../PaymentMode/Components/DebitCard/DebitCard';
import CreditCardSI from '../../PaymentMode/Components/CreditCard/CreditCardSI';
import DebitCardSI from '../../PaymentMode/Components/DebitCard/DebitCardSI';
import Netbanking from '../../PaymentMode/Components/NetBanking/Netbanking';
import UpiDetails from '../../PaymentMode/Components/UpiPayments/UpiDetails';
import UpiOtm from '../../PaymentMode/Components/UpiPayments/UpiOtm';
import UpiDetailsEmandate from '../../PaymentMode/Components/UpiPayments/UpiDetailsEmandate';
import WalletPayment from '../../PaymentMode/Components/WalletPayment/WalletPayment';
import PlanAccordion from '../../PaymentMode/Components/CommonDetails/PlanAccordion';
import EmiTabs from '../../PaymentMode/Components/EmiCard/EmiTabs';
import NcemiTabs from '../../PaymentMode/Components/NcemiCard/NcemiTabs';
import LowCostEmiTabs from '../../PaymentMode/Components/LowCostEmiCard/LowCostEmiTabs';
import Pos from '../../PaymentMode/Components/POS/Pos';
import NeftImps from '../../PaymentMode/Components/NEFTIMPS/NeftImps';
import PaymentStepsOne from '../../PaymentSteps/PaymentStepsOne';
import PaymentStepsSI from '../../PaymentSteps/PaymentStepsSI';
import PaymentError from '../../PaymentSteps/PaymentError';
import EmandateRegistered from '../../PaymentSteps/EmandateRegistered';
import PaymentSteps from '../../PaymentSteps/PaymentStepsRecurring';
import AadharRecurring from '../../PaymentMode/Components/Aadhar/AadharRecurring';
import EmandateOnDebit from '../../PaymentMode/Components/DebitCard/EmandateOnDebit';
import UpiDetailsRecurring from '../../PaymentMode/Components/UpiPayments/UpiDetailsRecurring';
import CustomizedDialogs from '../../../Shared/CustomDialogs';
import SkipAutoPay from '../../../Shared/SkipAutoPay';
import CreditCardRecurring from '../../PaymentMode/Components/CreditCard/CreditCardRecurring';
import NetbankingRecurring from '../../PaymentMode/Components/NetBanking/NetBankingRecurring';
import ApplePay from '../../PaymentMode/Components/ApplePay/ApplePay';
import { isAppleDevice } from '../../../Utility/deviceUtils';

export default function PaymentAccordion({ isSI ,  onCategoryValueChange }) {
    const [isShowLess, setIsShowLess] = useState(true);
    const [isShowPlanDetail, setIsShowPlanDetail] = useState(true);
    const [isShowProposerDetail, setShowProposerDetail] = useState(false);
    const [expanded, setExpanded] = useState(null);
    const [value, setValue] = useState(0);
    const [payModes, setPayModes] = useState([]);
    const [payModesToPass, setPayModesToPass] = useState([]);
    const [apiData, setApiData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [eligibleModes, setEligibleModes] = useState([]);
    const [eligibleRecurringModes, setEligibleRecurringModes] = useState([]);
    const [isDisplayModeFive, setIsDisplayModeFive] = useState(false);
    const [categoryValue, setCategoryValue] = useState(0);
    const [multiplier, setMultiplier] = useState(false);
    const isUpiModeAvailable = (data) =>
      !!data &&
      (data.isEligibleForUpiIntent ||
        data.isEligibleForIosPSPIntent ||
        data.isEligibleForUpiCollect ||
        data.showQrCodePayMode);

    const certifiedLogosStyle = {
        fontSize: '12px',
        color: '#0065FF',
        overflow: 'hidden',
        display: 'flex',
        // position: 'fixed',
        justifyContent: 'space-between', // Align items to the edges
        alignItems: 'center', // Vertically center items
        padding: '10px',
        width: '100%',
    };
    
    function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}



    useEffect(() => {
        const fetchData = async () => {
            try {
                const queryParameters = new URLSearchParams(window.location.search);
                const order = queryParameters.get("orderNo");
                const var1 = queryParameters.get("var1");
                const var2 = queryParameters.get("var2");
                const forceUpiIntent = queryParameters.get("forceUpiIntent");
                const temp = { orderNo: order, isMobileView: true };
                 let queryString = `?var1=${var1}&var2=${var2}`;
		 if (forceUpiIntent && forceUpiIntent.toLowerCase() === 'true') {
   		 queryString += `&forceUpiIntent=true`;
		 }
		    const response = await fetch(`/pay/securePayment/details/paymentModes${queryString}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(temp),
                });

                const data = await response.json();
                setApiData(data);
                setIsLoading(false);
                const extractedPayModes = data.beans.payModes;
                const codeList = extractedPayModes.map(method => method.code);
                setPayModes(codeList);
                setPayModesToPass(data.beans.payModes);
                const isApplePayDevice = isAppleDevice();
                const shouldShowApplePay = isApplePayDevice && data.showApplePay !== false;
                const filteredEligibleModes = shouldShowApplePay
                  ? data.eligibleModes
                  : data.eligibleModes.filter((mode) => mode.code !== 'APPLE_PAY');
                setEligibleModes(filteredEligibleModes);
                setEligibleRecurringModes(data.eligibleRecurringModes);
                if (data.displayMode === 5) {
     		   setIsDisplayModeFive(true);
      		}
      		if(data.tabIndex === 1){
      		 setCategoryValue(1);
      		}
                
            } catch (error) {
                console.error('API request error:', error);
            }
        };

        if (!apiData) {
            fetchData();
        }
    }, [apiData]);
    
       useEffect(() => {
 	  if (apiData && apiData.isMultiplier > 0) {
	    setMultiplier(true);
  	}
	}, [apiData]);


    useEffect(() => {

        if (eligibleModes.length > 0) {
            if (apiData.defaultMode) {
                for (let i = 0; i < eligibleModes.length; i++) {
                    if (eligibleModes[i].code === apiData.defaultMode) {
                        setValue(i);
                        break;
                    }
                }

            }
        }
    }, [eligibleModes, apiData]);

    

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : null);

    };
    
    const handleCategoryChange = (event, newCategoryValue) => {
    setCategoryValue(newCategoryValue);
    setValue(0); // Reset the payment mode tab to the first one when category changes
  };
   
   useEffect(() => {
    onCategoryValueChange(categoryValue); 
   }, [categoryValue]);

    const isParentOtmSuccess =
      !!apiData &&
      (apiData.isParentOtmSuccess === true || apiData.beans?.isParentOtmSuccess === true);
  
    return ( 
        <>
        {
            isLoading ? (
                <div>
          <Skeleton animation="wave" className="md:block" height={600} variant="text" />
          {/* Add more skeleton components as needed */}
        </div>
            ) : (
                <div className='card-view'>

          <div className='mt-10 lg:hidden'>
            <>
              {!isSI && <PaymentStepsOne/>}
              {isSI && <PaymentStepsSI/>}
            </>
          </div>
         <div className="payment-mob-view">
          <table className='w-full' >
                 {apiData.planDetails.map((insurer, index) => (
    <React.Fragment key={index}>
    <tr style={{ verticalAlign: 'top' }}>
     <td colSpan="2" style={{ verticalAlign: 'top' }}>
  <img class="source-logo"
    src={
      /^https?:\/\//i.test(insurer.insurerLogo)
        ? insurer.insurerLogo
        : `./images/${insurer.insurerLogo}`
    } 
    alt={insurer.insurerName} 
    style={{ maxWidth: '100%', height: 'auto' }} 
  />
</td>
     {!multiplier && <td colSpan="2" style={{ verticalAlign: 'top' }}>
        <div className='paying-card-head'>
          <div className='flex items-center justify-end'>
              <p>
                <span>Premium</span>
                <strong className='block'><i className='text-xs'><FontAwesomeIcon icon={faInr} /></i> {insurer.txAmount}</strong>
              </p>
              
          </div>
         </div>
      </td>}
        {multiplier && categoryValue === 1 && <td colSpan="2" style={{ verticalAlign: 'top' }}>
        <div className='paying-card-head'>
          <div className='flex items-center justify-end'>
              <p>
                <span>Premium</span>
                <strong className='block'><i className='text-xs'><FontAwesomeIcon icon={faInr} /></i>  {insurer.txAmount} </strong>
              </p>
              
          </div>
         </div>
      </td>}
       {multiplier && categoryValue === 0 && <td colSpan="2" style={{ verticalAlign: 'top' }}>
        <div className='paying-card-head'>
          <div className='flex items-center justify-end'>
              <p>
                <span>Premium</span>
                <strong className='block'><i className='text-xs'><FontAwesomeIcon icon={faInr} /></i>  {insurer.premium} * {insurer.multiplier}</strong>
              </p>
              
          </div>
         </div>
      </td>}
    </tr>
        <tr>
            <td colSpan="4">
                <div className='plan-name-below-logo' style={{ marginTop: '8px', marginBottom: '8px', fontSize: '14px', wordBreak: 'break-word', whiteSpace: 'normal', display: 'flex' }}>
                    <span style={{ color: '#888', fontSize: '14px', minWidth: '90px', flexShrink: 0 }}>Plan Name: </span><span style={{ fontSize: '14px' }}>{insurer.planName}</span>
                </div>
                {insurer.uinNo && insurer.uinNo !== 'null' && (
                    <div className='uin-below-logo' style={{ marginTop: '8px', marginBottom: '8px', fontSize: '14px', wordBreak: 'break-word', whiteSpace: 'normal', display: 'flex' }}>
                        <span style={{ color: '#888', fontSize: '14px', minWidth: '90px', flexShrink: 0 }}>UIN No: </span><span style={{ fontSize: '14px' }}>{insurer.uinNo}</span>
                    </div>
                )}
            </td>
        </tr>
    </React.Fragment>
  ))}
                        {!isShowLess  && (
                         <>
                        <tr>
                            <td colSpan="2">
                                <div className='border-tab'></div>
                            </td>
                            <td colSpan="2">
                                <div className='border-tab'></div>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="2">
                                <p>Premium amount</p>
                            </td>
                            <td colSpan="2">
                                <strong className='block'><i className='text-xs'><FontAwesomeIcon icon={faInr} /></i>{apiData.totalAmount} </strong>
                            </td>
                        </tr>
                      
                        </>
                    )}
                    </table>
         </div>
       {(!isDisplayModeFive &&   <div className='payment-accordion-box debit-card-box'>
            <h4 className='my-4' style={{ fontWeight: 'bold', marginLeft: '10px' }}>Choose payment mode</h4>
            {apiData.retry && <PaymentError retry = {apiData.retry} style={{ marginBottom: '16px' }}  />}
            {apiData.emandateRegistered && <EmandateRegistered style={{ marginBottom: '16px' }}  />}

         {eligibleModes.map((mode, index) => {
              switch(mode.code){
              case 'CC':  
               return(
                  <Accordion expanded={expanded === 'creditCard'} onChange={handleChange('creditCard')} className='shadow-none'>
                    <AccordionSummary
                      expandIcon={<FontAwesomeIcon icon={expanded === 'creditCard' ? faMinus : faPlus} />}
                      aria-controls="panel1bh-content"
                      id="panel1bh-header"
                    >
                      <Typography>
                        <ImageComponents name={'creditCard'} /> Credit Card
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <CreditCard secret={apiData.secret} cardDownBanks={apiData.cardDownBanks} />
                    </AccordionDetails>
                  </Accordion>
                )
               case 'DC':
                 return(
                    <Accordion expanded={expanded === 'debitCard'} onChange={handleChange('debitCard')} className='shadow-none' >
                      <AccordionSummary
                        expandIcon={<FontAwesomeIcon icon={expanded === 'debitCard' ? faMinus : faPlus} />}
                        aria-controls="panel3bh-content"
                        id="panel3bh-header"
                      >
                        <Typography>
                          <ImageComponents name={'creditCard'} /> Debit Card
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <DebitCard secret={apiData.secret} cardDownBanks={apiData.cardDownBanks} />
                      </AccordionDetails>
                    </Accordion>
                )
                case 'SI_CC':
                    return (<Accordion expanded={expanded === 'creditCard'} onChange={handleChange('creditCard')} className='shadow-none'>
                              <AccordionSummary
                                expandIcon={<FontAwesomeIcon icon={expanded === 'creditCard' ? faMinus : faPlus} />}
                                aria-controls="panel1bh-content"
                                id="panel1bh-header">
                                <Typography>
                                  <ImageComponents name={'creditCard'} /> Credit Card
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                <CreditCardSI secret={apiData.secret} cardDownBanks={apiData.cardDownBanks}
                                 displayMode = {apiData.displayMode} displayModeCheck = {apiData.displayModeCheck} />
                              </AccordionDetails>
                            </Accordion>);
                    break;
                case 'SI_DC':
                  return (<Accordion expanded={expanded === 'debitCard'} onChange={handleChange('debitCard')} className='shadow-none' >
                            <AccordionSummary
                              expandIcon={<FontAwesomeIcon icon={expanded === 'debitCard' ? faMinus : faPlus} />}
                              aria-controls="panel3bh-content"
                              id="panel3bh-header">
                              <Typography>
                                <ImageComponents name={'creditCard'} /> Debit Card
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <DebitCardSI secret={apiData.secret} cardDownBanks={apiData.cardDownBanks} 
                              displayMode = {apiData.displayMode} displayModeCheck = {apiData.displayModeCheck} />
                            </AccordionDetails>
                          </Accordion>);
                  break;
                case 'PPI':
                  return (
                    <Accordion expanded={expanded === 'wallet'} onChange={handleChange('wallet')} className='shadow-none' >
                      <AccordionSummary
                        expandIcon={<FontAwesomeIcon icon={expanded === 'wallet' ? faMinus : faPlus} />}
                        aria-controls="panel3bh-content"
                        id="panel3bh-header"
                      >
                        <Typography>
                          <ImageComponents name={'wallet'} /> Wallet
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <WalletPayment payModesToPass={payModesToPass} displayOrderNo={apiData.displayOrderNo} rzpWalletTextChangeToHide={apiData.rzpWalletTextChangeToHide} rzpWalletPartnerCode={apiData.rzpWalletPartnerCode} />
                      </AccordionDetails>
                    </Accordion>
                  )
                  case 'NB':
                     return (
                    <Accordion expanded={expanded === 'netbanking'} onChange={handleChange('netbanking')} className='shadow-none'>
                      <AccordionSummary
                        expandIcon={<FontAwesomeIcon icon={expanded === 'netbanking' ? faMinus : faPlus} />}
                        aria-controls="panel3bh-content"
                        id="panel3bh-header"
                      >
                        <Typography>
                          <ImageComponents name={'netbanking'} /> Netbanking
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Netbanking payModesToPass={payModesToPass} nbDownBanks={apiData.nbDownBanks} />
                      </AccordionDetails>
                    </Accordion>
                  )
                  case 'UPI':
                     const isUpiAvailable = isUpiModeAvailable(apiData);
                     if (!isUpiAvailable) {
                       return null;
                     }
                     return(
                    <Accordion expanded={expanded === 'UpiIcon'} onChange={handleChange('UpiIcon')} className='shadow-none' >
                      <AccordionSummary
                        expandIcon={<FontAwesomeIcon icon={expanded === 'UpiIcon' ? faMinus : faPlus} />}
                        aria-controls="panel3bh-content"
                        id="panel3bh-header"
                      >
                        <Typography>
                          <ImageComponents name={'UpiIcon'} /> UPI
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <UpiDetails payModesToPass={apiData} />
                      </AccordionDetails>
                    </Accordion>
                  )
                  case 'POS':
                    return (
                    <Accordion expanded={expanded === 'pos'} onChange={handleChange('pos')} className='shadow-none'>
                      <AccordionSummary
                        expandIcon={<FontAwesomeIcon icon={expanded === 'pos' ? faMinus : faPlus} />}
                        aria-controls="panel3bh-content"
                        id="panel3bh-header"
                      >
                        <Typography>
                          <ImageComponents name={'pos'} /> POS
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Pos />
                      </AccordionDetails>
                    </Accordion>
                  )
                  
                  case 'EMI':
                    return (
                      <Accordion expanded={expanded === 'emi'} onChange={handleChange('emi')} className='shadow-none'>
                        <AccordionSummary
                          expandIcon={<FontAwesomeIcon icon={expanded === 'emi' ? faMinus : faPlus} />}
                          aria-controls="panel3bh-content"
                          id="panel3bh-header"
                        >
                          <Typography>
                            <ImageComponents name={'easyEmi'} /> EMI
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <EmiTabs apiData = {apiData}/>
                        </AccordionDetails>
                      </Accordion>
                    )
                  case 'NCEMI':
                    return (
                      <Accordion expanded={expanded === 'ncemi'} onChange={handleChange('ncemi')} className='shadow-none'>
                        <AccordionSummary
                          expandIcon={<FontAwesomeIcon icon={expanded === 'ncemi' ? faMinus : faPlus} />}
                          aria-controls="panel3bh-content"
                          id="panel3bh-header"
                        >
                          <Typography>
                            <ImageComponents name={'easyEmi'} /> Easy EMI
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                             <NcemiTabs apiData = {apiData} />
                        </AccordionDetails>
                      </Accordion>
                    )
                  case 'lowCostEMI':
                    return (
                      <Accordion expanded={expanded === 'lowcostemi'} onChange={handleChange('lowcostemi')} className='shadow-none'>
                        <AccordionSummary
                          expandIcon={<FontAwesomeIcon icon={expanded === 'lowcostemi' ? faMinus : faPlus} />}
                          aria-controls="panel3bh-content"
                          id="panel3bh-header"
                        >
                          <Typography>
                            <ImageComponents name={'easyEmi'} /> Low Cost EMI
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                             <LowCostEmiTabs apiData = {apiData} />
                        </AccordionDetails>
                      </Accordion>
                    )
                  
                    case 'SMARTCOLLECT':
                      return (
                        <Accordion expanded={expanded === 'neft'} onChange={handleChange('neft')} className='shadow-none'>
                          <AccordionSummary
                            expandIcon={<FontAwesomeIcon icon={expanded === 'neft' ? faMinus : faPlus} />}
                            aria-controls="panel3bh-content"
                          id="panel3bh-header"
                        >
				<Typography>
                              <ImageComponents name={'pos'} /> NEFT/IMPS/RTGS
                              <span style={{ fontSize: '12px' }}>
                                (Pay Via Bank Account Transfer)
                              </span>
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <NeftImps payModesToPass={apiData} />
                          </AccordionDetails>
                        </Accordion>);
                    break;
                  case 'UPI_EMANDATE':
                    const isUpiEmandateAvailable = apiData.showUpiEmandateIntent || apiData.showEmanQrCode || apiData.isEligibleForUpiCollectEman;
                     if (!isUpiEmandateAvailable) {
                       return null;
                     }
                    return (<Accordion expanded={expanded === 'UpiIcon'} onChange={handleChange('UpiIcon')} className='shadow-none'>
                        <AccordionSummary
                          expandIcon={<FontAwesomeIcon icon={expanded === 'UpiIcon' ? faMinus : faPlus} />}
                          aria-controls="panel3bh-content"
                          id="panel3bh-header">
                          <Typography>
                            <ImageComponents name={'UpiIcon'} /> UPI Emandate
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <UpiDetailsEmandate
                            payMode={apiData.eligibleModes[index]}
                            productId={apiData.productId}
                            txAmount={apiData.amount}
                            showEmanQrCode={apiData.showEmanQrCode}
                            showUpiEmandateIntent={apiData.showUpiEmandateIntent}
                            isEligibleForUpiCollectEman={apiData.isEligibleForUpiCollectEman}
                          />
                        </AccordionDetails>
                      </Accordion>);
                    break;
                    
                    case 'UPI_OTM':
		         const isUpiOtmAvailableDisplayMode = apiData.isEligibleForUpiOTMIntent || apiData.isEligibleForUpiOTMQR || apiData.isEligibleForUpiOTMCollect;
                     if (!isUpiOtmAvailableDisplayMode) {
                       return null;
                     }
                    return (<Accordion expanded={expanded === 'UpiOtm'} onChange={handleChange('UpiOtm')} className='shadow-none'>
                        <AccordionSummary
                          expandIcon={<FontAwesomeIcon icon={expanded === 'UpiOtm' ? faMinus : faPlus} />}
                          aria-controls="panel3bh-content"
                          id="panel3bh-header">
                          <Typography component="div">
                            <span style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                              <ImageComponents name={'UpiIcon'} />
                              <span style={{ textAlign: 'left' }}>
                                Block payment <br />
                                <span style={{ fontSize: '11px' }}>via B-ASBA</span>
                              </span>
                            </span>
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <UpiOtm payModesToPass={apiData}/>
                        </AccordionDetails>
                      </Accordion>);
                    break;
                  case 'APPLE_PAY':
                    return (
                      <Accordion expanded={expanded === 'applePay'} onChange={handleChange('applePay')} className='shadow-none apple-pay-accordion'>
                        <AccordionSummary
                          className='apple-pay-accordion-summary'
                          expandIcon={<FontAwesomeIcon icon={expanded === 'applePay' ? faMinus : faPlus} />}
                          aria-controls="panel-applepay-content"
                          id="panel-applepay-header"
                        >
                          <Typography component="span" className='apple-pay-accordion-label'>
                            <FaApplePay className='apple-pay-accordion-icon' aria-hidden size={26}/>
                            <span className='apple-pay-accordion-text'>Apple Pay</span>
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <ApplePay apiData={apiData} />
                        </AccordionDetails>
                      </Accordion>
                    );

              default:
                break; 
            }
          })}
          <PlanAccordion />
            

                
          </div>)}
          
         {(isDisplayModeFive && <div className='payment-accordion-box debit-card-box'>
          <Tabs
              value={categoryValue}
              onChange={handleCategoryChange}
              aria-label="Payment Mode Categories"
              variant="fullWidth"
              sx={{ marginBottom: 2 }}
            >
              <Tab label="One Time Payment" {...a11yProps(0)} />
              <Tab label="Recurring Payment" {...a11yProps(1)} />
            </Tabs>
            <h4 className='my-4' style={{ fontWeight: 'bold', marginLeft: '10px' }}>Choose payment mode</h4>
            {apiData.retry && <PaymentError retry = {apiData.retry} style={{ marginBottom: '16px' }}  />}

       {categoryValue === 0 && eligibleModes.map((mode, index) => {
              switch(mode.code){
              case 'CC':  
               return(
                  <Accordion expanded={expanded === 'creditCard'} onChange={handleChange('creditCard')} className='shadow-none'>
                    <AccordionSummary
                      expandIcon={<FontAwesomeIcon icon={expanded === 'creditCard' ? faMinus : faPlus} />}
                      aria-controls="panel1bh-content"
                      id="panel1bh-header"
                    >
                      <Typography>
                        <ImageComponents name={'creditCard'} /> Credit Card
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <CreditCard secret={apiData.secret} cardDownBanks={apiData.cardDownBanks} />
                    </AccordionDetails>
                  </Accordion>
                )
               case 'DC':
                 return(
                    <Accordion expanded={expanded === 'debitCard'} onChange={handleChange('debitCard')} className='shadow-none' >
                      <AccordionSummary
                        expandIcon={<FontAwesomeIcon icon={expanded === 'debitCard' ? faMinus : faPlus} />}
                        aria-controls="panel3bh-content"
                        id="panel3bh-header"
                      >
                        <Typography>
                          <ImageComponents name={'creditCard'} /> Debit Card
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <DebitCard secret={apiData.secret} cardDownBanks={apiData.cardDownBanks} />
                      </AccordionDetails>
                    </Accordion>
                )
                case 'SI_CC':
                    return (<Accordion expanded={expanded === 'creditCard'} onChange={handleChange('creditCard')} className='shadow-none'>
                              <AccordionSummary
                                expandIcon={<FontAwesomeIcon icon={expanded === 'creditCard' ? faMinus : faPlus} />}
                                aria-controls="panel1bh-content"
                                id="panel1bh-header">
                                <Typography>
                                  <ImageComponents name={'creditCard'} /> Credit Card
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                <CreditCardSI secret={apiData.secret} cardDownBanks={apiData.cardDownBanks}
                                 displayMode = {apiData.displayMode} displayModeCheck = {apiData.displayModeCheck} />
                              </AccordionDetails>
                            </Accordion>);
                    break;
                case 'SI_DC':
                  return (<Accordion expanded={expanded === 'debitCard'} onChange={handleChange('debitCard')} className='shadow-none' >
                            <AccordionSummary
                              expandIcon={<FontAwesomeIcon icon={expanded === 'debitCard' ? faMinus : faPlus} />}
                              aria-controls="panel3bh-content"
                              id="panel3bh-header">
                              <Typography>
                                <ImageComponents name={'creditCard'} /> Debit Card
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <DebitCardSI secret={apiData.secret} cardDownBanks={apiData.cardDownBanks} 
                              displayMode = {apiData.displayMode} displayModeCheck = {apiData.displayModeCheck} />
                            </AccordionDetails>
                          </Accordion>);
                  break;
                case 'PPI':
                  return (
                    <Accordion expanded={expanded === 'wallet'} onChange={handleChange('wallet')} className='shadow-none' >
                      <AccordionSummary
                        expandIcon={<FontAwesomeIcon icon={expanded === 'wallet' ? faMinus : faPlus} />}
                        aria-controls="panel3bh-content"
                        id="panel3bh-header"
                      >
                        <Typography>
                          <ImageComponents name={'wallet'} /> Wallet
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <WalletPayment payModesToPass={payModesToPass} rzpWalletTextChangeToHide={apiData.rzpWalletTextChangeToHide} rzpWalletPartnerCode={apiData.rzpWalletPartnerCode} />
                      </AccordionDetails>
                    </Accordion>
                  )
                  case 'NB':
                     return (
                    <Accordion expanded={expanded === 'netbanking'} onChange={handleChange('netbanking')} className='shadow-none'>
                      <AccordionSummary
                        expandIcon={<FontAwesomeIcon icon={expanded === 'netbanking' ? faMinus : faPlus} />}
                        aria-controls="panel3bh-content"
                        id="panel3bh-header"
                      >
                        <Typography>
                          <ImageComponents name={'netbanking'} /> Netbanking
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Netbanking payModesToPass={payModesToPass} nbDownBanks={apiData.nbDownBanks} />
                      </AccordionDetails>
                    </Accordion>
                  )
                  case 'UPI':
                     const isUpiAvailableDisplayMode = isUpiModeAvailable(apiData);
                     if (!isUpiAvailableDisplayMode) {
                       return null;
                     }
                     return(
                    <Accordion expanded={expanded === 'UpiIcon'} onChange={handleChange('UpiIcon')} className='shadow-none' >
                      <AccordionSummary
                        expandIcon={<FontAwesomeIcon icon={expanded === 'UpiIcon' ? faMinus : faPlus} />}
                        aria-controls="panel3bh-content"
                        id="panel3bh-header"
                      >
                        <Typography>
                          <ImageComponents name={'UpiIcon'} /> UPI
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <UpiDetails payModesToPass={apiData} />
                      </AccordionDetails>
                    </Accordion>
                  )
                  case 'POS':
                    return (
                    <Accordion expanded={expanded === 'pos'} onChange={handleChange('pos')} className='shadow-none'>
                      <AccordionSummary
                        expandIcon={<FontAwesomeIcon icon={expanded === 'pos' ? faMinus : faPlus} />}
                        aria-controls="panel3bh-content"
                        id="panel3bh-header"
                      >
                        <Typography>
                          <ImageComponents name={'pos'} /> POS
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Pos />
                      </AccordionDetails>
                    </Accordion>
                  )
                  
                  case 'EMI':
                    return (
                      <Accordion expanded={expanded === 'emi'} onChange={handleChange('emi')} className='shadow-none'>
                        <AccordionSummary
                          expandIcon={<FontAwesomeIcon icon={expanded === 'emi' ? faMinus : faPlus} />}
                          aria-controls="panel3bh-content"
                          id="panel3bh-header"
                        >
                          <Typography>
                            <ImageComponents name={'easyEmi'} /> EMI
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <EmiTabs apiData = {apiData}/>
                        </AccordionDetails>
                      </Accordion>
                    )
                  case 'NCEMI':
                    return (
                      <Accordion expanded={expanded === 'ncemi'} onChange={handleChange('ncemi')} className='shadow-none'>
                        <AccordionSummary
                          expandIcon={<FontAwesomeIcon icon={expanded === 'ncemi' ? faMinus : faPlus} />}
                          aria-controls="panel3bh-content"
                          id="panel3bh-header"
                        >
                          <Typography>
                            <ImageComponents name={'easyEmi'} /> Easy EMI
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                             <NcemiTabs apiData = {apiData} />
                        </AccordionDetails>
                      </Accordion>
                    )
                  case 'lowCostEMI':
                    return (
                      <Accordion expanded={expanded === 'lowcostemi'} onChange={handleChange('lowcostemi')} className='shadow-none'>
                        <AccordionSummary
                          expandIcon={<FontAwesomeIcon icon={expanded === 'lowcostemi' ? faMinus : faPlus} />}
                          aria-controls="panel3bh-content"
                          id="panel3bh-header"
                        >
                          <Typography>
                            <ImageComponents name={'easyEmi'} /> Low Cost EMI
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                             <LowCostEmiTabs apiData = {apiData} />
                        </AccordionDetails>
                      </Accordion>
                    )
                  
                    case 'SMARTCOLLECT':
                      return (
                        <Accordion expanded={expanded === 'neft'} onChange={handleChange('neft')} className='shadow-none'>
                          <AccordionSummary
                            expandIcon={<FontAwesomeIcon icon={expanded === 'neft' ? faMinus : faPlus} />}
                            aria-controls="panel3bh-content"
                          id="panel3bh-header"
                        >
				<Typography>
                              <ImageComponents name={'pos'} /> NEFT/IMPS/RTGS
                              <span style={{ fontSize: '12px' }}>
                                (Pay Via Bank Account Transfer)
                              </span>
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <NeftImps payModesToPass={apiData} />
                          </AccordionDetails>
                        </Accordion>);
                    break;
                  case 'APPLE_PAY':
                    return (
                      <Accordion expanded={expanded === 'applePay'} onChange={handleChange('applePay')} className='shadow-none apple-pay-accordion'>
                        <AccordionSummary
                          className='apple-pay-accordion-summary'
                          expandIcon={<FontAwesomeIcon icon={expanded === 'applePay' ? faMinus : faPlus} />}
                          aria-controls="panel-applepay-content"
                          id="panel-applepay-header"
                        >
                          <Typography component="span" className='apple-pay-accordion-label'>
                            <FaApplePay className='apple-pay-accordion-icon' aria-hidden size={26}/>
                            <span className='apple-pay-accordion-text'>Apple Pay</span>
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <ApplePay apiData={apiData} />
                        </AccordionDetails>
                      </Accordion>
                    );

              default:
                break; 
            }
          })}

	 {categoryValue === 1 && eligibleRecurringModes.map((mode, index) => {
              switch(mode.code){
             case 'EMANDATE_NB':
                return (<Accordion expanded={expanded === 'netbanking'} onChange={handleChange('netbanking')} className='shadow-none' >
                          <AccordionSummary
                            expandIcon={<FontAwesomeIcon icon={expanded === 'netbanking' ? faMinus : faPlus} />}
                            aria-controls="panel3bh-content"
                            id="panel3bh-header">
                            <Typography>
                              <ImageComponents name={'netbanking'} /> Netbanking
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                          <NetbankingRecurring payModesToPass={payModesToPass} displayOrderNo={apiData.encryptParentOrderNo} eMandateNo={apiData.eMandateNo}
                                     maxAmountLimit={apiData.maxAmountLimit} parentOrderNo={apiData.parentOrderNo} order_id={apiData.order_id} cust_id={apiData.cust_id} mid={apiData.mid}
                                     expire_at={apiData.expire_at} orderNo={apiData.encryptParentOrderNo} productId = {apiData.productId}
                                     isParentOtmSuccess={isParentOtmSuccess} />
                          </AccordionDetails>
                        </Accordion>);
                break;
                 case 'EMANDATE_ADHR':
                    return (<Accordion expanded={expanded === 'pos'} onChange={handleChange('pos')} className='shadow-none' >
                              <AccordionSummary
                                expandIcon={<FontAwesomeIcon icon={expanded === 'pos' ? faMinus : faPlus} />}
                                aria-controls="panel3bh-content"
                                id="panel3bh-header">
                                <Typography>
                                  <ImageComponents name={'pos'} /> Aadhar Card
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                              <AadharRecurring payModesToPass={payModesToPass} displayOrderNo={apiData.encryptParentOrderNo} eMandateNo={apiData.eMandateNo}
                                         maxAmountLimit={apiData.maxAmountLimit} parentOrderNo={apiData.parentOrderNo} order_id={apiData.order_id} cust_id={apiData.cust_id} mid={apiData.mid}
                                         expire_at={apiData.expire_at} orderNo={apiData.encryptParentOrderNo} productId = {apiData.productId}
                                         isParentOtmSuccess={isParentOtmSuccess} />
                              </AccordionDetails>
                            </Accordion>);
                    break;
                    case 'RECURRING_DC':
                        return (<Accordion expanded={expanded === 'sidebitCard'} onChange={handleChange('sidebitCard')} className='shadow-none' >
                                  <AccordionSummary
                                    expandIcon={<FontAwesomeIcon icon={expanded === 'sidebitCard' ? faMinus : faPlus} />}
                                    aria-controls="panel3bh-content"
                                    id="panel3bh-header">
                                    <Typography>
                                      <ImageComponents name={'creditCard'} /> Debit Card
                                    </Typography>
                                  </AccordionSummary>
                                  <AccordionDetails>
                                   <EmandateOnDebit payModesToPass={payModesToPass} displayOrderNo={apiData.encryptParentOrderNo} eMandateNo={apiData.eMandateNo}
                                       maxAmountLimit={apiData.maxAmountLimit} parentOrderNo={apiData.parentOrderNo} order_id={apiData.order_id} cust_id={apiData.cust_id} mid={apiData.mid}
                                       expire_at={apiData.expire_at} sidcBankNote={apiData.sidcBankNote} secret={apiData.secret} cardDownBanks = {apiData.cardDownBanks}
                                       productId = {apiData.productId} srcSupplierId = {apiData.srcSupplierId} displayMode = {apiData.displayMode} orderNo={apiData.orderNo}
                                       isParentOtmSuccess={isParentOtmSuccess} />
                                  </AccordionDetails>
                                </Accordion>);
                        break;
                      case 'UPI_EMANDATE':
                        const isUpiEmandateAvailableDisplayMode = apiData.showUpiEmandateIntent || apiData.showEmanQrCode || apiData.isEligibleForUpiCollectEman;
                        if (!isUpiEmandateAvailableDisplayMode) {
                          return null;
                        }
                        return (<Accordion expanded={expanded === 'upieman'} onChange={handleChange('upieman')} className='shadow-none'>
                            <AccordionSummary
                              expandIcon={<FontAwesomeIcon icon={expanded === 'upieman' ? faMinus : faPlus} />}
                              aria-controls="panel3bh-content"
                              id="panel3bh-header">
                              <Typography>
                                <ImageComponents name={'UpiIcon'} /> UPI Emandate
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <UpiDetailsRecurring
                                payMode={apiData.eligibleRecurringModes[index]}
                                productId={apiData.productId}
                                txAmount={apiData.amount}
                                showEmanQrCode={apiData.showEmanQrCode}
                                showUpiEmandateIntent={apiData.showUpiEmandateIntent}
                                isEligibleForUpiCollectEman={apiData.isEligibleForUpiCollectEman}
                                isParentOtmSuccess={isParentOtmSuccess}
                              />
                            </AccordionDetails>
                          </Accordion>);
                        break;
                         case 'SI_CC':
                    return (<Accordion expanded={expanded === 'sicreditCard'} onChange={handleChange('sicreditCard')} className='shadow-none'>
                              <AccordionSummary
                                expandIcon={<FontAwesomeIcon icon={expanded === 'sicreditCard' ? faMinus : faPlus} />}
                                aria-controls="panel1bh-content"
                                id="panel1bh-header">
                                <Typography>
                                  <ImageComponents name={'creditCard'} /> Credit Card
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                              <CreditCardRecurring  secret={apiData.secret} cardDownBanks = {apiData.cardDownBanks}
                                     productId = {apiData.productId} srcSupplierId = {apiData.srcSupplierId} displayMode = {apiData.displayMode}
                                     isParentOtmSuccess={isParentOtmSuccess} />
                              </AccordionDetails>
                            </Accordion>);
                    break;	

              default:
                break;             }
          })}

           
          <PlanAccordion categoryValue = {categoryValue} />
            

                
          </div>)}
          
          <div style={certifiedLogosStyle} className="certified-logos hideSmall">
              <p className="left">
                <a href="https://www.policybazaar.com/legal-and-admin-policies/" target="_blank" rel="noopener noreferrer">
                  Privacy Policy
                </a>
                {'  |  '}
                <a href="https://www.policybazaar.com/legal-and-admin-policies/#termsofuse" target="_blank" rel="noopener noreferrer">
                  Terms & Conditions
                </a>
                {'  |  '}
                <a href="https://payment.policybazaar.com/pay/faq.jsp" target="_blank" rel="noopener noreferrer">
                  FAQ
                </a>
              </p>    <p className="right rightOne">
                <a href="https://www.5tattva.com/verify/ftzdkix4sq" target="_blank" rel="noopener noreferrer">
              
                  <img
                    src="./images/pci-dss-certified@2x.png"
                    alt="PCI DSS Certified"
                    width="84"
                  />
                </a>
              </p>
        </div>
        </div>
            )
        }

        </>
    );
}
